export enum TestAttributes {
  ANSWER = 'ANSWER',
  OPTION = 'OPTION',
  NEXT = 'NEXT',
  SUBMIT = 'SUBMIT',
  SKIP = 'SKIP',
  OPEN_PAYMENT_MODAL = 'OPEN_PAYMENT_MODAL',
  ZODIAC_IMAGE = 'ZODIAC_IMAGE',
}
